import React, { useEffect } from "react";
import MatchListing from "./common/liveCenter/matchListing/MatchListing";
import { ColorVariables } from "../utils/general";


// New wrapper components
import BasketballMatchWidgetWrap from "./widgetBoxes/basketball/BasketballMatchWidgetWrap";
import BasketballTeamWidgetWrap from "./widgetBoxes/basketball/BasketballTeamWidgetWrap";
import BasketballLeagueWidgetWrap from "./widgetBoxes/basketball/BasketballLeagueWidgetWrap";


const BasketballWidgets = ({
  dataId,
  dataType,
  sport,
  difference,
  head,
  data,
  headData,
  baseUrl,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setDate,
  date,
  setIsLive,
  isLive,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
}) => {
  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await fetch(`${baseUrl}/settings`, {
          headers: {
            Token: process.env.REACT_APP_SETTINGS_TOKEN,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error(res.statusText);

        const settings = await res.json();
        const cssVars = ColorVariables(settings);

        const styleTag = document.createElement("style");
        styleTag.textContent = cssVars;
        document.head.appendChild(styleTag);

        document.querySelectorAll(".microservice-cont")?.forEach((el) => el?.classList.add("hydrated"));


        return () => {
          if (document.head.contains(styleTag)) {
            document.head.removeChild(styleTag);
          }
        };
      } catch (err) {
        console.error("Failed to load settings:", err);
      }
    };

    loadSettings();
  }, [baseUrl]);

  const commonProps = {
    dataId,
    dataType,
    sport,
    difference,
    head,
    data,
    headData,
    baseUrl,
    loadCSS,
    setDataId,
    setDataType,
    setHead,
    setDate,
    date,
    setIsLive,
    isLive,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
  };

  if (dataType === "live-match-detail" || dataType === "live-centre") {
    return <MatchListing {...commonProps} data={data?.data} matchType="all" socketUrl={process.env.REACT_APP_SOCKET || 'https://socket-bolsaas.6lgx.com/'} />;
  }

  if (dataType?.startsWith("basketball-match")) {
    return <BasketballMatchWidgetWrap {...commonProps} socketUrl={process.env.REACT_APP_SOCKET || 'https://socket-bolsaas.6lgx.com/'}
      channel="BasketballMatch"
      event={`BasketballMatchDetails-${dataId}`} />;
  }

  if (dataType?.startsWith("basketball-league-")) {
    return <BasketballLeagueWidgetWrap {...commonProps} />;
  }

  if (dataType?.startsWith("basketball-team-")) {
    return <BasketballTeamWidgetWrap {...commonProps} />;
  }

  return <h1>Widget Not Found in Basketball !</h1>;
};

export default BasketballWidgets;
